import { ReactElement } from 'react';
import { Modal } from '@weareopenr/component-library';
import { IUser } from 'src/types';
import { UserForm } from './UserForm';

const UserModal = ({
  show,
  closeModal,
  user,
}: {
  show: boolean;
  closeModal: () => void;
  user?: IUser;
}): ReactElement => {
  return (
    <Modal open={show} closeModal={closeModal}>
      <UserForm closeModal={closeModal} user={user} />
    </Modal>
  );
};

export default UserModal;
